/**
 * uuid - For generating unique keys inside of objects.
 *@example
 * const myUuid = uuid()
 * console.log(myUuid); //Output:'3e2eb47a-0eb1-4b4c-a98d-88d6261bc665'
 * @returns {string} a random/unique with a length of 36 charactes.
 */
const uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export default uuid;
